import * as layout from '../../../components/markLayout.module.css';
import { MarkTimeInput, MarkLabel } from '../../../components/MarkControls';
import React, { useId } from 'react';
import P from '@hero/ui-kit/typography/P';
export type Step3Data = {
    sendWindowStart: string;
    sendWindowEnd: string;
};
type Props = {
    data: Step3Data;
    onChange: (data: Step3Data) => void;
    errors: string[];
};
const Step3Schedule: React.FC<Props> = ({ data, onChange, errors }) => {
    const startId = useId();
    const endId = useId();
    return (
        <div className={layout.form}>
            <P
                noDefaultMargin
                size="small"
                styles={{
                    color: 'var(--mark-muted)',
                    fontStyle: 'italic'
                }}
            >
                Optional. If the drip uses email, the window must fit inside 08:00–21:00. If it uses
                SMS, inside 10:00–20:00. Mixed drips must overlap both.
            </P>
            <div className={layout.fieldGrid}>
                <div className={layout.field}>
                    <MarkLabel
                        htmlFor={startId}
                        style={{
                            display: 'block',
                            marginBottom: '0.4rem'
                        }}
                    >
                        Send window start
                    </MarkLabel>
                    <MarkTimeInput
                        id={startId}
                        data-field="send-window-start"
                        value={data.sendWindowStart}
                        onChange={(e) =>
                            onChange({ ...data, sendWindowStart: e.currentTarget.value })
                        }
                    />
                </div>
                <div className={layout.field}>
                    <MarkLabel
                        htmlFor={endId}
                        style={{
                            display: 'block',
                            marginBottom: '0.4rem'
                        }}
                    >
                        Send window end
                    </MarkLabel>
                    <MarkTimeInput
                        id={endId}
                        data-field="send-window-end"
                        value={data.sendWindowEnd}
                        onChange={(e) =>
                            onChange({ ...data, sendWindowEnd: e.currentTarget.value })
                        }
                    />
                </div>
            </div>
            <P
                noDefaultMargin
                size="small"
                styles={{
                    color: 'var(--mark-muted)'
                }}
            >
                Leave both empty for no window restriction. Both must be set, or both empty.
            </P>
            {errors.length > 0 && (
                <div role="alert" aria-live="polite" className={layout.notice}>
                    {errors.map((e) => (
                        <P
                            key={e}
                            noDefaultMargin
                            size="small"
                            styles={{
                                color: 'var(--mark-danger)'
                            }}
                        >
                            {e}
                        </P>
                    ))}
                </div>
            )}
        </div>
    );
};
export default Step3Schedule;
